import React from 'react';

function PageNotFound() {
  return <div>Page Not found</div>;
}

export default PageNotFound;
